import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TaskModel } from '../model/task.model';
import { TaskService } from '../task.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-task-edit',
  templateUrl: './task-edit.component.html',
  styleUrls: ['./task-edit.component.scss'],
  standalone: false
})
export class TaskEditComponent implements DirtyCheck {
  title: string = "New Task";
  editForm: FormGroup;
  taskInfo: TaskModel = {};
  isFormDirty: boolean = false;
  permission: any;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private taskService: TaskService,
    private snackBarService: SnackBarService,
    private permissionService: PermissionService
  ) {
    let id = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      code: [this.taskInfo.code, [Validators.required, Validators.maxLength(50)]],
      name: [this.taskInfo.name, [Validators.required, Validators.maxLength(100)]],
      description: [this.taskInfo.description],
      bg_color: [this.taskInfo.bg_color || '#ffffff'],
      fg_color: [this.taskInfo.fg_color || '#000000'],
      is_active: [this.taskInfo.is_active !== undefined ? this.taskInfo.is_active : 1]
    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    if (id !== null && parseInt(id) !== 0) {
      this.setTaskInfo(id);
    }
    this.permission = this.permissionService.getRowPermission(this.permissionService.getPagePermission("task"), id);
  }

  isDirty(): boolean {
    return this.isFormDirty;
  }

  navBack(): void {
    this.router.navigate(['/system/task']);
  }

  setTaskInfo(id: any): void {
    this.taskService.getTaskById(id).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.taskInfo = response.data.task;
          this.editForm.patchValue(this.taskInfo);
          this.title = this.getTitle();
          this.isFormDirty = false;
        } else {
          this.snackBarService.openSnackBar({ message: response.message, title: 'Failed!!!', type: 'error' });
        }
      }
    });
  }

  getTitle(): string {
    return (!this.taskInfo.id || this.taskInfo.id == 0) ? "New Task" : "Editing : " + this.taskInfo.name;
  }

  save(): void {
    if (this.editForm.valid) {
      Object.assign(this.taskInfo, this.editForm.value);
      this.taskService.update(this.taskInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            this.isFormDirty = false;
            this.snackBarService.openSnackBar({
              type: 'success',
              title: 'Saved',
              message: `Record for ${this.taskInfo.name} has been updated successfully.`
            });
            this.router.navigate(['/system/task']);
          } else {
            this.snackBarService.openSnackBar({ message: response.message, title: 'Failed!!!', type: 'error' });
          }
        }
      });
    } else {
      this.editForm.markAllAsTouched();
    }
  }
}
